import styles from "./Separator.module.scss"

const Separator: React.FC = () => {
  return <div className={styles.separator} />
}

export default Separator
